import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export interface PortfolioItemUsage {
  floats: number;
  submissions: number;
}

/** Keyed by portfolio item id. Items with no copies in floats or submissions are absent. */
export type PortfolioUsage = Record<string, PortfolioItemUsage>;

/**
 * How many floats and submissions hold a copy of each of the candidate's
 * portfolio files and videos. Removing one of those items from the profile
 * also removes it from them, so the editor warns first.
 */
export default function usePortfolioUsage(candidateUuid: string | undefined, enabled = true) {
  const axios = useAxios();

  return useQuery({
    queryKey: ["candidatePortfolioUsage", candidateUuid],
    queryFn: async (): Promise<PortfolioUsage> => {
      const response = await axios.get(`/candidate/${candidateUuid}/portfolio/usage`);
      return response.data ?? {};
    },
    enabled: enabled && !!candidateUuid,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
